module.exports = __webpack_public_path__ + "img/values_white.679bc441.svg";